<template>
  <form>
    <br />
    <img src="@/assets/images/dnevna.png" alt="" />
    <p class="subtitle has-text-weight-bold">
      {{ nazivKarte }}
    </p>
    <p class="subtitle">{{ cenaKarte }} дин</p>
    <div class="columns">
      <div class="column is-one-third">
        <b-field
          label="Регистарски број таблица"
          :type="$v.broj_tablica.$error ? 'is-danger' : ''"
          :message="$v.broj_tablica.$error ? 'Број таблица није исправан' : ''"
        >
          <b-input v-model="broj_tablica" placeholder="PNXXXYY"></b-input>
        </b-field>
      </div>
      <div class="column is-one-third">
        <b-field
          label="Позив на број"
          :type="$v.poziv_na_broj.$error ? 'is-danger' : ''"
          :message="$v.poziv_na_broj.$error ? 'Позив не број је обавезан' : ''"
        >
          <b-input
            v-model="poziv_na_broj"
            placeholder="Позив на број са дневне паркинг карте"
          ></b-input>
        </b-field>
      </div>
    </div>
    <!-- <div class="columns">
      <div class="column">
        <b-field label="Прималац">
          <div class="control is-clearfix">
            Јавно предузеће Дирекција за изградњу општине Параћин
          </div>
        </b-field>
      </div>
      <div class="column">
        <b-field
          label="Износ (дин)"
          :type="$v.iznos.$error ? 'is-danger' : ''"
          :message="$v.iznos.$error ? 'Износ је обавезан' : ''"
        >
          <b-input v-model="iznos"></b-input>
        </b-field>
      </div>
    </div> -->
    <div class="columns">
      <div class="column">
        <b-field
          label="Корисник паркинг места"
          :type="$v.uplatilac.$error ? 'is-danger' : ''"
          :message="
            $v.uplatilac.$error ? 'Корисник паркинг места је обавезан' : ''
          "
        >
          <b-input v-model="uplatilac" placeholder="Име и презиме"></b-input>
        </b-field>
      </div>
      <div class="column">
        <!-- <b-field label="Број рачуна">
          <div class="control is-clearfix">
            160-0000000462420-13
          </div>
        </b-field> -->
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <!-- <b-field label="Сврха уплате">
          <div class="control is-clearfix">
            {{ svrha_uplate }} {{ poziv_na_broj }}
          </div>
        </b-field> -->
      </div>
      <div class="column"></div>
    </div>
    <b-button class="is-pulled-left" @click="onNazadClick">Назад</b-button>
    <b-button class="is-pulled-right" @click="onDodajUKorpuClick"
      >Додај у корпу</b-button
    >
  </form>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
//import moment from 'moment'
import {
  required,
  minLength,
  maxLength,
  integer
} from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      broj_tablica: '',
      tip_karte: 'DK06', // tabela dnevne karte stavka 6
      primalac: 'DIRPN', // DIRPN
      iznos: 0,
      uplatilac: '',
      broj_racuna: '160-0000000462420-13', // 160-0000000462420-13
      svrha_uplate: 'Општа дневна карта',
      poziv_na_broj: ''
    }
  },
  methods: {
    onDodajUKorpuClick() {
      this.iznos = this.cenaKarte
      this.svrha_uplate = this.nazivKarte

      this.$v.$touch()

      if (this.$v.$invalid) {
        console.log('ERROR')
        return
      }

      const stavka = {
        broj_tablica: this.broj_tablica,
        tip_karte: this.tip_karte,
        primalac: this.primalac,
        iznos: this.iznos,
        uplatilac: this.uplatilac,
        broj_racuna: this.broj_racuna,
        svrha_uplate: this.svrha_uplate + ' ' + this.poziv_na_broj,
        poziv_na_broj: this.poziv_na_broj
      }

      this.$store.dispatch('placanje/dodajUKorpu', stavka)
      this.$emit('proizvodDodat')
    },
    onNazadClick() {
      this.$emit('nazad')
    }
  },
  computed: {
    nazivKarte() {
      let stavka = this.dajStavkuCenovnikaPoId(this.tip_karte)
      return stavka ? stavka.naziv_karte : ''
    },
    cenaKarte() {
      let stavka = this.dajStavkuCenovnikaPoId(this.tip_karte)
      return stavka ? stavka.cena : 0
    },
    ...mapState('placanje', ['cenovnik']),
    ...mapGetters('placanje', ['dajStavkuCenovnikaPoId'])
  },
  validations: {
    broj_tablica: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(8)
    },
    iznos: {
      required,
      integer
    },
    uplatilac: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(100)
    },
    poziv_na_broj: {
      required
    }
  }
}
</script>

<style></style>
